module.exports = __webpack_public_path__ + "static/img/index_bg.30ec055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_bg.png
// module id = 837Z
// module chunks = 0